var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-imovel-denominacao", {
        attrs: {
          required: false,
          imovel: _vm.cadastro.imovel,
          tipoCadastro: "INFORMACOES"
        }
      }),
      _c("app-matricula-imovel", {
        attrs: { imovel: _vm.cadastro.imovel, required: false }
      }),
      _c("app-imovel-dados-titulo", {
        attrs: { imovel: _vm.cadastro.imovel, required: false }
      }),
      _c("app-documentos", {
        attrs: {
          maxSize: 25,
          "valid-extensions": ["doc", "docx", "jpeg", "jpg", "pdf", "png"],
          documentos: _vm.cadastro.imovel.documentos,
          tiposDocumentos: _vm.documentos,
          observer: _vm.observer,
          aba: "Imovel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed9e2548", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed9e2548","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/solicitarInformacao/components/Imovel.vue
// module id = null
// module chunks = 